import api from "utils/api";
import { CONSENT_TYPE } from "utils/constants";

export default function useSubscribeToOffers() {
  const subscribeToOffers = async (firebaseToken, profileId, consentType = CONSENT_TYPE.OPT_IN) => {
    try {
      const result = await api.subscribeToOffers(firebaseToken, {
        profileId: profileId,
        consentType: consentType,
      });
      return result.data;
    } catch (error) {
      console.error("Failed to subscribe to offers:", error);
      throw error;
    }
  };

  return { subscribeToOffers };
}
